// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Dialog_Icon__3DRcb"};